import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSwitch,{staticClass:"tema-eixo-combo",attrs:{"id":"temas-select","disabled":_vm.disabled},on:{"change":function($event){return _vm.$emit('onChange')}},model:{value:(_vm.editValue.habilitado),callback:function ($$v) {_vm.$set(_vm.editValue, "habilitado", $$v)},expression:"editValue.habilitado"}})
}
var staticRenderFns = []

export { render, staticRenderFns }